module.exports = __webpack_public_path__ + "img/word.b145848b.svg";